import React from "react";

import { DropdownSelectOption } from "..";
import { CheckIcon } from "../../../icons_v2/general";
import { HStack, Box, Text, Pressable, Divider } from "../../../primitive";
import { CheckBox } from "../../CheckBox/CheckBox";

type ItemProps<T> = {
  isMulti?: boolean;
  item: DropdownSelectOption<T>;
  isSelected: boolean;
  onPress: () => void;
  testID?: string;
};

export const Item = <T extends string | number | null>({
  isMulti,
  item,
  isSelected,
  onPress,
  testID,
}: ItemProps<T>) => {
  return (
    <>
      <Pressable
        width="100%"
        key={item.value}
        disabled={!!item.isDisabled}
        accessibilityRole="button"
        accessibilityState={{ disabled: !!item.isDisabled }}
        onPress={onPress}
        borderRadius="2"
        backgroundColor="surface-primary"
        paddingHorizontal={3}
        paddingVertical={4}
        testID={testID}
        _hover={{
          backgroundColor: item.isDisabled
            ? "surface-primary"
            : "grayscale-100",
        }}
        _focus={{
          backgroundColor: item.isDisabled
            ? "surface-primary"
            : "grayscale-100",
        }}
        _pressed={{
          backgroundColor: item.isDisabled
            ? "surface-primary"
            : "grayscale-200",
        }}
      >
        <HStack justifyContent="space-between" width="100%">
          <HStack gap={3} flex={1}>
            {item.leftElement ? (
              <Box marginRight={1}>{item.leftElement}</Box>
            ) : null}
            <Text
              variant="mainBaseSemiBold"
              color={
                item.isDisabled
                  ? "text-disabled"
                  : isSelected
                  ? "text-main-primary-inverse"
                  : "text-primary"
              }
            >
              {item.label}
            </Text>
            {item.rightElement ? (
              <Text
                variant="mainBaseSemiBold"
                color={
                  item.isDisabled
                    ? "text-disabled"
                    : isSelected
                    ? "text-main-primary-inverse"
                    : "text-primary"
                }
              >
                {item.rightElement}
              </Text>
            ) : null}
            <Text
              variant="mainBaseMedium"
              color={
                item.isDisabled
                  ? "text-secondary"
                  : isSelected
                  ? "text-main-primary-inverse"
                  : "text-secondary"
              }
            >
              {item.subLabel}
            </Text>
          </HStack>
          {isMulti ? (
            <Box pointerEvents="none">
              <CheckBox
                isChecked={isSelected}
                isDisabled={item.isDisabled}
                testID={`${testID}-checkbox`}
              />
            </Box>
          ) : isSelected ? (
            <CheckIcon color="text-main-primary" />
          ) : null}
        </HStack>
      </Pressable>
      {item.showUnderline ? (
        <Box width="100%" paddingHorizontal={1} marginTop={2} marginBottom={2}>
          <Divider />
        </Box>
      ) : null}
    </>
  );
};
